export default "__VITE_ASSET__BMSeCPbc__"